<template>
    <div
        class="hts-select-option"
        :class="{ 'hts-select-option__disabled': disabled }">
        <ul class="flex gap-2 flex-wrap">
            <li
                v-for="(item, index) in items"
                :key="index"
                class="inline-block align-middle">
                <div
                    class="hts-select-option__item"
                    :class="{ active: item[selectKey] === modelValue, ...(item.class || {}) }"
                    @click="handleClick(item)">
                    <hts-icons
                        v-if="item.icon || item.svg || item.iconName"
                        class="mr-1"
                        :icon="item.icon"
                        :svg="item.svg"
                        :icon-name="item.iconName"
                        :color="item.iconColor" />
                    <span>
                        {{ $t(item.name || item[selectLabel]) }}
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: [Number, String, Array, Boolean] as PropType<number | string | boolean | any[] | null | undefined>,
  items: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  disabled: Boolean,
  readonly: Boolean,
  selectKey: {
    type: String,
    default: 'value'
  },
  selectLabel: {
    type: String,
    default: 'label'
  }
})
const { items, disabled, readonly, selectKey, selectLabel } = toRefs(props)
const emits = defineEmits(['update:modelValue', 'change'])
const handleClick = (item: any) => {
  if (disabled.value || readonly.value) {
    return
  }
  emits('update:modelValue', item[selectKey.value])
  emits('change', item[selectKey.value])
}
</script>
